import React, { Component } from 'react'
import { history, routePath } from 'routes'
import { ContentBlock } from 'components/common'
import { AppState, Dispatch } from '../../store/types'
import { bindActionCreators } from 'redux'
import { createAccount } from '../../ducks/auth/operations'
import {
  fetchConfiguration,
  fetchConfigurationLogo,
  fetchConfigurationLogoHeader
} from '../../ducks/references/operations'
import { connect } from 'react-redux'
import LogoTip from '../../components/UI/LogoTip/index.js'
import { Buttons, WelcomeWrap } from '../EstimatesStartPage/styles'
import TextInput from '../../components/UI/TextInput'
import styled from 'styled-components'
import { Button } from '../../components/UI/Button'
import { handleErrorMessageAlert } from '../../components/UI/Alert'
import { setEmilToStore } from '../../ducks/auth/actions'

interface State {
  form: {
    email: string
  }
  errors: {
    email?: string
  }
}

class EstimateCreationByEmail extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      form: {
        email: ''
      },
      errors: {
        // email: ''
      }
    }
  }
  onUpdate = (name: string, value: string) => {
    this.setState((prevState: State) => ({
      ...prevState,
      form: {
        ...prevState.form,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }))
  }
  onClick = () => {
    const { errors } = this.state
    const { email } = this.state.form
    const { setEmilToStore: setEmail } = this.props
    let errorsLoc = {}
//    if (!email) {
//      const errorText = 'Email can`t be empty'
//      errorsLoc = { ...errors, email: errorText }
//      handleErrorMessageAlert(errorText)
//    }
    if (Object.entries(errorsLoc).length !== 0) {
      this.setState({ errors: { ...this.state.errors, ...errorsLoc } })
      return
    }
    // return false
    setEmail(email)
    history.push(routePath.ESTIMATE_CREATE)
  }
  render() {
    const {
      errors,
      form: { email }
    } = this.state
    return (
      <ContentBlock isCentered={true}>
        <LogoTip />
        <WelcomeWrap>
          <Title>Welcome to the Patient Estimator</Title>
          <TextInput
            name={'email'}
            value={email}
            label={'Email'}
            placeholder={'Email Address'}
            errorLabel={errors.email}
            handleChange={this.onUpdate}
          />
          <Buttons>
            {/*<Link variant={'default'} to={routePath.ESTIMATE_CREATE}>*/}
            {/*  Get Started*/}
            {/*</Link>*/}
            <Button variant={'default'} onClick={this.onClick}>
              Get Started
            </Button>
          </Buttons>
        </WelcomeWrap>
      </ContentBlock>
    )
  }
}

// export default EstimatesStartPage

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    { createAccount, fetchConfiguration, fetchConfigurationLogo, fetchConfigurationLogoHeader, setEmilToStore },
    dispatch
  )

interface EstimatesStartPageProps {
  isAuthenticated: boolean
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps & EstimatesStartPageProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimateCreationByEmail)

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
  margin-bottom: 30px;
`
